import {Container} from '../../components/Container';
import React, {memo} from 'react';
import {ScenarioPage} from '../../components/ScenarioPage';

export const ScenarioScreen = memo(function ScenarioScreen() {

    return (
        <Container>
            <div className="page-wrapper">
                <ScenarioPage/>
            </div>
        </Container>
    );
});
